// This app's public web address, for links people share (group and festival
// invites). Per environment (.env*): app.loudneighbors.com in production --
// also what the native apps ship, since they build in production mode --
// and staging.loudneighbors.com on staging, so a staging invite never points
// at production. Unset locally, where the page's own origin is right.
export const APP_URL = import.meta.env.VITE_APP_URL || window.location.origin;
